import React, { useState, useEffect } from "react";
import LoginPage from "../../components/LoginPage";
import { useHistory } from "react-router-dom";
import { LOGIN_USER } from "../../GraphQL/Mutations";
import { GET_CONFIGURATION } from "../../GraphQL/Queries";
import { useMutation, useLazyQuery } from "@apollo/client";
import { NotificationManager } from "react-notifications";
import { cookie } from "../../util/JWTCookie";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import PropTypes from "prop-types";

const LoginPageContainer = ({
  handleLogin,
  isAuthenticated,
  userInfo,
}) => {
  const history = useHistory();
  const [loginUser] = useMutation(LOGIN_USER);
  const [form, setForm] = useState({
    username: "",
  });
  const [termsAndConditions, setTermsAndConditions] = useState("");
  const [manualTwoFactor, setManualTwoFactor] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [existsQR, setExistsQR] = useState(false);
  const [codeQR, setCodeQR] = useState("");
  const [code, setCode] = useState("");

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setCode(value);
  };

  const handleInput = (event) => {
    if (event.keyCode == 13) {
      event.preventDefault();
    }
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      history.push("/home");
    }
  }, [isAuthenticated]);

  const SignIn = () => {
    setShowLoader(true);
    loginUser({
      variables: {
        user: form.username,
        password: form.password,
        code: "",
      },
      context: { clientName: "LinkUsers" },
    })
      .then((value) => {
        if (!value.data.userLogin?.loginSuccess) {
          setShowLoader(false);
          NotificationManager.warning(
            value.data.userLogin.loginMessage,
            "",
            5000
          );
        } else {
          setShowLoader(false);
          if (value.data.userLogin.useTotp) {
            setCodeQR(value.data.userLogin.qrCode);
            setExistsQR(value.data.userLogin.qrExists);
            setShowVerify(true);
          } else {
            cookie.set("TrustSafety", value.data.userLogin);
            history.push("/Home");
          }
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  const SignInVerify = () => {
    setShowLoader(true);
    if (code !== undefined && code.trim().length > 0) {
      loginUser({
        variables: {
          user: form.username,
          password: form.password,
          code: code,
        },
        context: { clientName: "LinkUsers" },
      })
        .then((value) => {
          if (!value.data.userLogin.loginSuccess) {
            setShowLoader(false);
            NotificationManager.warning(
              value.data.userLogin.loginMessage,
              "",
              5000
            );
          } else {
            setShowLoader(false);
            if (value.data.userLogin.accessToken !== "") {
              cookie.set("TrustSafety", value.data.userLogin);
              history.push("/Home");
            } else {
              NotificationManager.warning("Invalid Code", "", 5000);
            }
          }
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    } else {
      setShowLoader(false);
      NotificationManager.warning("Invalid Code", "", 5000);
    }
  };

  const [getTermsandConditions] = useLazyQuery(GET_CONFIGURATION, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data.configurationByKey.length > 0) {
        setTermsAndConditions(data.configurationByKey[0].value);
      }
    },
  });

  const [getManualTwoFactor] = useLazyQuery(GET_CONFIGURATION, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data.configurationByKey.length > 0) {
        setManualTwoFactor(data.configurationByKey[0].value);
      }
    },
  });

  useEffect(() => {
    getTermsandConditions({
      variables: {
        key: "TERMS_AND_CONDITIONS",
      },
      context: { clientName: "LinkUsers" },
    });

    getManualTwoFactor({
      variables: {
        key: "TWO_FACTOR_AUTHENTICATION",
      },
      context: { clientName: "LinkUsers" },
    });
    return () => {
      setShowLoader(false);
    };
  }, []);

  return (
    <>
      <LoginPage
        handleInput={handleInput}
        handleChange={handleChange}
        SignIn={SignIn}
        SignInVerify={SignInVerify}
        handleLogin={handleLogin}
        termsAndConditions={termsAndConditions}
        manualTwoFactor={manualTwoFactor}
        showVerify={showVerify}
        codeQR={codeQR}
        existsQR={existsQR}
        code={code}
      ></LoginPage>
      {showLoader && <ModalLoader />}
    </>
  );
};

export default LoginPageContainer;

LoginPageContainer.propTypes = {
  handleLogin: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  userInfo: PropTypes.object,
}
